import { render, staticRenderFns } from "./SetupProfile.vue?vue&type=template&id=03fd1c71&"
import script from "./SetupProfile.vue?vue&type=script&lang=js&"
export * from "./SetupProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports